import { useRouteError } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import StatusMessage from '@shared/components/StatusMessage';
import { isChunkLoadError } from './lazyWithRetry';

/**
 * Router-level error boundary. React Router catches errors thrown while rendering
 * a route (including a lazy import that ultimately rejects) and renders this instead
 * of its default "Unexpected Application Error!" stack trace. Chunk-load failures get
 * a "new version available" message with a reload; everything else falls back to the
 * generic error message.
 */
export default function RouteErrorBoundary() {
  const isChunkError = isChunkLoadError(useRouteError());

  return (
    <StatusMessage
      title={isChunkError ? 'A new version of Maverick is available.' : 'Something went wrong.'}
      action={isChunkError && (
        <Button themeColor="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>
      )}
    />
  );
}
